import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { BUSINESS } from '../../config/businessInfo';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold text-primary-400 mb-4">
              LeaserTech
            </h3>
            <p className="text-gray-300 mb-3">
              {BUSINESS.storeType}. Siparişleriniz kargo ile Türkiye geneline gönderilir; fiziksel mağaza
              bulunmamaktadır.
            </p>
            <p className="text-gray-400 text-sm leading-relaxed">
              Vergi No: {BUSINESS.taxNumber}
              <br />
              {BUSINESS.taxOffice}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Hızlı Linkler</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-300 hover:text-primary-400 transition-colors">
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-300 hover:text-primary-400 transition-colors">
                  Tüm Ürünler
                </Link>
              </li>
              <li>
                <Link to="/products?category=Şarj Aleti" className="text-gray-300 hover:text-primary-400 transition-colors">
                  Şarj Aleti
                </Link>
              </li>
              <li>
                <Link to="/products?category=Powerbank" className="text-gray-300 hover:text-primary-400 transition-colors">
                  Powerbank
                </Link>
              </li>
              <li>
                <Link to="/products?category=Kulaklık" className="text-gray-300 hover:text-primary-400 transition-colors">
                  Kulaklık
                </Link>
              </li>
              <li>
                <Link to="/products?category=Hoparlör" className="text-gray-300 hover:text-primary-400 transition-colors">
                  Hoparlör
                </Link>
              </li>
              <li>
                <Link to="/products?category=Telefon Aksesuarları" className="text-gray-300 hover:text-primary-400 transition-colors">
                  Telefon Aksesuarları
                </Link>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Müşteri Hizmetleri</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/help" className="text-gray-300 hover:text-primary-400 transition-colors">
                  Yardım Merkezi
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-primary-400 transition-colors">
                  İletişim
                </Link>
              </li>
              <li>
                <Link to="/shipping" className="text-gray-300 hover:text-primary-400 transition-colors">
                  Kargo & Teslimat
                </Link>
              </li>
              <li>
                <Link to="/returns" className="text-gray-300 hover:text-primary-400 transition-colors">
                  İade & Değişim
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-300 hover:text-primary-400 transition-colors">
                  Sık Sorulan Sorular
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">İletişim Bilgileri</h4>
            <div className="space-y-3">
              <div className="flex items-center">
                <MapPin className="h-5 w-5 text-primary-400 mr-3" />
                <span className="text-gray-300">{BUSINESS.address}</span>
              </div>
              <div className="flex items-center">
                <Phone className="h-5 w-5 text-primary-400 mr-3 flex-shrink-0" />
                <span className="text-gray-300">{BUSINESS.phone}</span>
              </div>
              <div className="flex items-start">
                <Mail className="h-5 w-5 text-primary-400 mr-3 flex-shrink-0 mt-0.5" />
                <span className="text-gray-300">
                  {BUSINESS.emailInfo}
                  <br />
                  {BUSINESS.emailContact}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              © {new Date().getFullYear()} {BUSINESS.brandName}. Tüm hakları saklıdır. · {BUSINESS.storeType}
            </div>
            <div className="flex flex-wrap gap-4 text-sm">
              <Link to="/returns" className="text-gray-400 hover:text-primary-400 transition-colors">
                İade & Değişim
              </Link>
              <Link to="/shipping" className="text-gray-400 hover:text-primary-400 transition-colors">
                Kargo & Teslimat
              </Link>
              <Link to="/privacy" className="text-gray-400 hover:text-primary-400 transition-colors">
                Gizlilik Politikası
              </Link>
              <Link to="/terms" className="text-gray-400 hover:text-primary-400 transition-colors">
                Kullanım Şartları
              </Link>
              <Link to="/cookies" className="text-gray-400 hover:text-primary-400 transition-colors">
                Çerez Politikası
              </Link>
              <Link to="/distance-selling" className="text-gray-400 hover:text-primary-400 transition-colors">
                Mesafeli Satış Sözleşmesi
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

